import { CellFormatOptions, Icon } from '@octano/global-ui';
import { useEffect, useRef, useState } from 'react';
import { PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap';
import { DiscountTexts } from '../../../api/requests/studyPlansOffer';
import { TuitionContinuityProcessDetailStudentResponseDto } from '../../../api/requests/tuitionContinuityProcessManagement';

const TuitionContinuityProcessManagementDiscountField = ({
  options,
}: {
  options: CellFormatOptions<TuitionContinuityProcessDetailStudentResponseDto>;
}) => {
  const spanRef = useRef<HTMLSpanElement | null>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const discounts = options.row.discounts;

  useEffect(() => {
    if (spanRef.current) {
      setPopoverOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spanRef.current]);

  if (!discounts || discounts.length === 0) {
    return null; // O manejar el caso en que no hay descuentos
  }

  const uniqueId = `key_${options.row.id}`;

  return (
    <>
      <span ref={spanRef} id={uniqueId}>
        <Icon name="eye" size={16} />
      </span>
      {popoverOpen && (
        <UncontrolledPopover placement="left" target={uniqueId}>
          <PopoverHeader>Descuentos asignados</PopoverHeader>
          <PopoverBody style={{ maxHeight: '300px', overflow: 'auto' }}>
            <ul>
              {discounts.map((discount) => (
                <li key={discount.id}>
                  {DiscountTexts[discount.type]} - {discount.name} -
                  {discount.percentage}% - {discount.code}
                </li>
              ))}
            </ul>
          </PopoverBody>
        </UncontrolledPopover>
      )}
    </>
  );
};

export default TuitionContinuityProcessManagementDiscountField;
